import { useWizard } from "react-use-wizard";
import NavigateBack from "../../components/navigateBack";
import OTP from "../../components/otp";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const useTokenState = createPersistedState("token");

function MobileVerifyStep({
  qKey,
  question,
  otpNumber = null,
  patientId = null,
  onSubmitHandler,
}) {
  const { previousStep, nextStep } = useWizard();
  const _qKey = qKey;
  const [token, setToken] = useTokenState();
  const { t } = useTranslation();
  const [isResendingOTP, setIsResendingOTP] = useState(false);

  const URL = "/api/v1/users/register/otp/verify";
  const ResendOTPURL = (mobileNumber) =>
    `/api/v1/users/register/otp/${mobileNumber}`;
  const ResendOTPURLMasked = (userId) =>
    `/api/v1/users/register/recover/otp/${userId}`;

  const verifyOTP = (data) => {
    return fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({
        tid: token,
        ...data,
      }),
    }).then((response) => response.json());
  };

  const resendOTP = (mobileNumber) => {
    setIsResendingOTP(true);
    if (patientId !== null && mobileNumber.includes("XX")) {
      //TODO: Find a better way to know if phone is masked
      return fetch(ResendOTPURLMasked(patientId), { method: "GET" })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData["status"]["success"]) {
            setToken(responseData["tid"]);
          }
        })
        .finally(() => setIsResendingOTP(false));
    } else {
      return fetch(ResendOTPURL(mobileNumber), { method: "POST" })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData["status"]["success"]) {
            setToken(responseData["tid"]);
          }
        })
        .finally(() => setIsResendingOTP(false));
    }
  };

  const onNextFn = (data) => {
    onSubmitHandler({ [_qKey]: data });
    nextStep();
  };

  return (
    <>
      <NavigateBack onClickHandler={previousStep} />
      <OTP
        question={question}
        toVerify={otpNumber}
        verifyCall={verifyOTP}
        onSubmitHandler={onNextFn}
        patientId={patientId}
        resendOTPCall={resendOTP}
        goBackHandler={previousStep}
        isResendingOTP={isResendingOTP}
        ctaText={t("login.DOBSTEP.button")}
      />
    </>
  );
}

export default MobileVerifyStep;
